export default "__VITE_ASSET__pqGY35SI__"